
<div class="flex-row full-stretch snackbar-container flex--justify-between flex--align-center gap-standard">  

    <mat-icon class="type-icon" [color]="color">{{this.icon}}</mat-icon>

    
    <h6 [class]="'mat-body-1 margin-none' + textClass" >
        <ng-container *ngFor="let messagePart of messageParts">

            <span *ngIf="messagePart.type==='span'" [class]="textClass">
                {{messagePart.text | translate}}
            </span>
            
            <a [class]="textClass" *ngIf="messagePart.type==='a'" [href]="data.linkUrl" target="_blank"> 
                {{data.action | translate}}
            </a>
        </ng-container>

    </h6>
    

    <button *ngIf="data.action && !data.linkUrl && !hasLinkOutlet" (click)="dismissWithAction()"  mat-raised-button [color]="color"> {{data.action | translate}}</button>
    
    <a      *ngIf="data.linkUrl && !hasLinkOutlet" [href]="data.linkUrl" target="_blank" mat-raised-button [color]="color"> {{data.action | translate}}</a>

    <button *ngIf="!data.hideClose;else ph"
            class="snackbar-close-btn" 
            mat-icon-button 
            (click)="dismiss()"
    >
        <mat-icon [color]="color">close</mat-icon>
    </button>

    <ng-template #ph>
        <div></div>
    </ng-template>
</div>
